import React from "react";
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { MdEventNote } from "react-icons/md";
import Card from "horizon/components/card/Card";

/**
 * Builds the subtitle for the reservations header card.
 * @param {number} count - Items on the current view
 * @returns {string}
 */
function buildSubtitle(count) {
  if (count === 0) return "Aucune réservation à afficher";
  const plural = count > 1 ? "s" : "";
  return `${count} dernière${plural} réservation${plural}`;
}

/**
 * Renders the reservations page header card with event icon, title, count subtitle.
 * @param {Object} props
 * @param {number} props.count - Items on the current view
 * @returns {React.ReactElement}
 */
function ReservationsHeader({ count }) {
  const titleColor = useColorModeValue("secondaryGray.900", "white");
  const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
  return (
    <Card>
      <Flex align="center" gap="14px">
        <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
          <Icon as={MdEventNote} w="22px" h="22px" color="brand.500" />
        </Flex>
        <Flex direction="column" minW="0">
          <Text fontSize="lg" fontWeight="700" color={titleColor}>Réservations</Text>
          <Text fontSize="sm" color={subColor} noOfLines={1}>{buildSubtitle(count)}</Text>
        </Flex>
      </Flex>
    </Card>
  );
}

export default ReservationsHeader;
